import EFPicture from 'elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function I() {
    const { useLang, useRouter, useState, useEffect, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('RV');
    const [gap, setGap] = useState(24);
    const [source, setSource] = useState('');

    const youtube_source_map: any = {
        us: [
            'https://www.youtube.com/embed/9bNoTn3p-6A?si=o6yOKIljGybh_O03',
            'https://www.youtube.com/embed/Oul_73XvFBE?si=Nu9lls62gJnk-SgS',
            'https://www.youtube.com/embed/NvxhzqQuz0I?si=sL-QnNx6eMT_SfPn',
            'https://www.youtube.com/embed/kWywaw73bRk?si=Swxe8Lxyvh8bz_ut',
        ],
        kr: [
            'https://www.youtube.com/embed/sIE5YwXdcHU?si=HTOJrTYDouQeLyKX',
            'https://www.youtube.com/embed/Qary2XW2Roc?si=jVxcQ84ctCWZ31TO',
            'https://www.youtube.com/embed/fGuR27dx7I0?si=HfLt45Z0vQmpHyZS',
            'https://www.youtube.com/embed/19IaApnmOSA?si=am4MfXqEw1dmcysl',
            'https://www.youtube.com/embed/fVl32DT_QPc?si=XllPjJ90--XOtoqH',
        ],
    };

    const youtube_source = youtube_source_map[locale] || youtube_source_map.us;

    const cards = [
        {
            title: t('I_card1_title'),
            text: t('I_card1_text'),
            author: t('I_card1_author'),
            source: youtube_source[0],
        },
        {
            title: t('I_card2_title'),
            text: t('I_card2_text'),
            author: t('I_card2_author'),
            source: youtube_source[1],
        },
        {
            title: t('I_card3_title'),
            text: t('I_card3_text'),
            author: t('I_card3_author'),
            source: youtube_source[2],
        },
        {
            title: t('I_card4_title'),
            text: t('I_card4_text'),
            author: t('I_card4_author'),
            source: youtube_source[3],
        },
    ];

    if (locale === 'kr') {
        cards.push({
            title: t('I_card5_title'),
            text: t('I_card5_text'),
            author: t('I_card5_author'),
            source: youtube_source[4],
        });
    }
    const IMGS_MAP: any = {
        us: [
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080473271/9_1.jpg',
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080495085/9_2.jpg',
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080509429/9_3.jpg',
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080528276/9_4.jpg',
        ],
        kr: [
            'https://websiteoss.ecoflow.com/upload/image/1720686469467/poster_1.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1720686470038/poster_2.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1720686470285/poster_3.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1720686469267/poster_4.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1720686469921/poster_5.jpg',
        ],
    };

    const IMGS = IMGS_MAP[locale] || IMGS_MAP.us;

    const AUTHORS_MAP: any = {
        us: [
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080548123/9_1_author.jpg',
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080556874/9_2_author.jpg',
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080566696/9_3_author.jpg',
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080575319/9_4_author.jpg',
        ],
        kr: [
            'https://websiteoss.ecoflow.com/upload/image/1720686470502/author_kr_1.png',
            'https://websiteoss.ecoflow.com/upload/image/1720686618688/author_kr_2.png',
            'https://websiteoss.ecoflow.com/upload/image/1720686470831/author_kr_3.png',
            'https://websiteoss.ecoflow.com/upload/image/1720686618868/author_kr_4.png',
            'https://websiteoss.ecoflow.com/upload/image/1720686470666/author_kr_5.png',
        ],
    };

    const AUTHORS = AUTHORS_MAP[locale] || AUTHORS_MAP.us;

    const handlePlay = (card: any, k: number) => {
        setSource(card?.source);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: card?.title,
            position: `RV_${k + 1}`,
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1024 && window.innerWidth < 1441 ? 20 : 24);
        }
    }, []);

    return (
        <div id="RV-I" className={`RV-I RV-box ${css['RV-I']}`}>
            <div className="info-box">
                <p className="title">{t('I_title')}</p>
            </div>
            <Swiper className="cards swiper-box" modules={[Navigation]} spaceBetween={gap} slidesPerView={'auto'} initialSlide={0} navigation={true}>
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className="swiper-item" key={k}>
                        <div className="card-img" onClick={() => handlePlay(card, k)}>
                            <EFPicture src={IMGS[k]} alt={card?.text} />
                            <p className="card-title">{card.title}</p>
                            <svg className="play-icon" xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill="none">
                                <path
                                    d="M54.4729 15.515C54.1858 14.368 53.6012 13.3172 52.778 12.4685C51.9548 11.6199 50.9222 11.0035 49.7846 10.6816C45.6279 9.66663 29.0012 9.66663 29.0012 9.66663C29.0012 9.66663 12.3746 9.66663 8.21789 10.7783C7.08023 11.1002 6.04766 11.7165 5.22447 12.5652C4.40128 13.4138 3.81662 14.4647 3.52955 15.6116C2.76882 19.8301 2.39671 24.1094 2.41789 28.3958C2.39077 32.7145 2.76291 37.0264 3.52955 41.2766C3.84604 42.3879 4.44379 43.3988 5.26507 44.2116C6.08634 45.0244 7.10337 45.6117 8.21789 45.9166C12.3746 47.0283 29.0012 47.0283 29.0012 47.0283C29.0012 47.0283 45.6279 47.0283 49.7846 45.9166C50.9222 45.5948 51.9548 44.9784 52.778 44.1297C53.6012 43.2811 54.1858 42.2302 54.4729 41.0833C55.2278 36.8966 55.5998 32.6499 55.5846 28.3958C55.6117 24.0771 55.2395 19.7651 54.4729 15.515Z"
                                    fill="#FF0200"
                                />
                                <path d="M23.5625 36.2984L37.4583 28.3959L23.5625 20.4934V36.2984Z" fill="white" />
                            </svg>
                        </div>
                        <div className="card-info pc">
                            <div className="card-author-img">
                                <EFPicture src={[AUTHORS[k]]} alt={card?.author} />
                            </div>
                            <div className="card-content">
                                <p className="card-text">{card.text}</p>
                                <p className="card-author">{card.author}</p>
                            </div>
                        </div>
                        <div className="card-info h5">
                            <p className="card-text">{card.text}</p>
                            <div className="card-author-box">
                                <div className="card-author-img">
                                    <EFPicture src={AUTHORS[k]} alt={card?.author} />
                                </div>
                                <p className="card-author">{card.author}</p>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <EFVideoModal visible={Boolean(source)} source={source} onClose={() => setSource('')} playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'} />
        </div>
    );
}
